import React, { useState } from 'react'
import { Button, Card, CardContent, Grid, ToggleButton, ToggleButtonGroup } from '@mui/material'
import GameRecordTable from './GameRecordTable'
import { Duel, Game, isWin as _isWin } from 'model/Game'
import { User } from 'model/User'

import { Report } from 'model/Report'
import * as reportRepository from 'repository/ReportRepository'

type Props = {
  format: 'BO1' | 'BO3'
  user: User
  media: { isPc: boolean }
  game: Game
  report: Report
  setReportedEmpty: (bool: boolean) => void
  setReportedByLoser: (bool: boolean) => void
  setIsNotMatchFormat: (bool: boolean) => void
}
export default function Recorder(props: Props) {
  /**
   * 結果記録周りの制御
   */
  const [isFirst, setIsFirst] = useState(true)
  const [isWin, setIsWin] = useState(true)
  const [duels, setDuels] = useState<Duel[]>([])

  function handleRecord() {
    const _duels = duels.slice()
    _duels.push({game_number: duels.length + 1 ,is_first: isFirst, is_win: isWin})
    setDuels(_duels)
  }

  function handleRemoveRecord() {
    const _duels = duels.slice()
    _duels.pop()
    setDuels(_duels)
  }

  async function handleReport() {
    if (duels.length === 0) {
      props.setReportedEmpty(true)
      props.setReportedByLoser(false)
      props.setIsNotMatchFormat(false)
      return
    }
    if (!_isWin(duels)) {
      props.setReportedEmpty(false)
      props.setReportedByLoser(true)
      props.setIsNotMatchFormat(false)
      return
    }
    if (props.format === 'BO1' && duels.length !== 1) {
      props.setReportedEmpty(false)
      props.setReportedByLoser(false)
      props.setIsNotMatchFormat(true)
      return
    }
    props.setReportedEmpty(false)
    props.setReportedByLoser(false)
    props.setIsNotMatchFormat(false)

    const report = Object.assign({}, props.report)
    report.uuid = props.user.uuid
    report.history ? report.history.push(props.user.uuid) : report.history = [props.user.uuid]
    report.duels = duels
    report.agreed = null
    report.report_time = new Date().getTime()
    reportRepository.update(report)
  }

  const disabledInput = (props.report.agreed === true) ||
    (!!props.game.end_time) ||
    (props.report.uuid === props.user.uuid && props.report.agreed === null)

  return (
    <>
      <Card variant='outlined' sx={
        {
          flex: 1,
          overflow: 'auto',
          mx: props.media.isPc ? 5 : 2
        }
      }>
        <CardContent>
          <Grid container spacing={props.media.isPc ? 2 : 1} rowSpacing={2}>
            <Grid item xs={1} md={2} />
            <Grid item xs={5} md={4} textAlign='center'>
              <ToggleButtonGroup
                value={isFirst}
                exclusive
                size={props.media.isPc ? 'medium' : 'small'}
                onChange={(event, n) => {
                  if (n !== null) setIsFirst(n)
                }}
                disabled={disabledInput}
              >
                <ToggleButton value={true}>先攻</ToggleButton>
                <ToggleButton value={false}>後攻</ToggleButton>
              </ToggleButtonGroup>
            </Grid>
            <Grid item xs={5} md={4} textAlign='center'>
              <ToggleButtonGroup
                color='primary'
                value={isWin}
                exclusive
                size={props.media.isPc ? 'medium' : 'small'}
                onChange={(event, n) => {
                  if (n !== null) setIsWin(n)
                }}
                disabled={disabledInput}
              >
                <ToggleButton value={true}>勝ち</ToggleButton>
                <ToggleButton value={false}>負け</ToggleButton>
              </ToggleButtonGroup>
            </Grid>
            <Grid item xs={1} md={2} />

            <Grid item xs={1} md={2} />
            <Grid item xs={5} md={4} textAlign='center'>
              <Button
                color='warning'
                variant='outlined'
                size={props.media.isPc ? 'medium' : 'small'}
                fullWidth
                onClick={handleRemoveRecord}
                disabled={disabledInput}
              >
                ひとつ削除
              </Button>
            </Grid>
            <Grid item xs={5} md={4} textAlign='center'>
              <Button
                variant='outlined'
                size={props.media.isPc ? 'medium' : 'small'}
                fullWidth
                onClick={handleRecord}
                disabled={disabledInput}
              >
                記録する
              </Button>
            </Grid>
            <Grid item xs={1} md={2} />
          </Grid>

          <Grid container sx={{ pt:props.media.isPc ? 2 : 1 }} spacing={{xs: 1, md: 2}}>
            <Grid item xs={1} md={2}/>
            <Grid item xs={10} md={8}>
              <GameRecordTable media={props.media} duels={duels} />
            </Grid>
            <Grid item xs={1} md={2} />
            
            <Grid item xs={1} md={2} />
            <Grid item xs={10} md={8} textAlign='center'>
              <Button
                color='success'
                variant='outlined'
                size={props.media.isPc ? 'medium' : 'small'}
                fullWidth
                onClick={handleReport}
                disabled={disabledInput}
              >
                報告する
              </Button>
            </Grid>
            <Grid item xs={1} md={2} />
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}